import { render } from "./ButtonPagination.vue?vue&type=template&id=6a558d46&scoped=true"
import script from "./ButtonPagination.vue?vue&type=script&lang=js"
export * from "./ButtonPagination.vue?vue&type=script&lang=js"

import "./ButtonPagination.vue?vue&type=style&index=0&id=6a558d46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a558d46"]])

export default __exports__